import "swiper/css";
import "swiper/css/navigation";
import type { FunctionComponent } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";

import { useCurrentPageType } from "shared/hooks";
import type { Edition } from "shared/lib/edition";

import {
  Container,
  MenuItem,
  StyledBaseEntityLink,
  StyledSwiper,
  StyledSwiperSlide,
} from "scmp-app/components/header/header-oneline-menu-container/header-oneline-menu/styles";
import type { headerOnelineMenuItemsQuery } from "scmp-app/queries/__generated__/headerOnelineMenuItemsQuery.graphql";

export type Props = { edition: Edition };
export const HeaderOnelineMenuItems: FunctionComponent<Props> = ({ edition }) => {
  const queryReference = useLazyLoadQuery<headerOnelineMenuItemsQuery>(
    graphql`
      query headerOnelineMenuItemsQuery {
        pwaOnelineMenu: appConfig(filter: { entityId: "scmp_pwa_oneline_menu" }) {
          json
        }
      }
    `,
    {},
  );

  const onelineMenuAppConfig = queryReference?.pwaOnelineMenu?.json as
    | ScmpPwaOnelineMenuAppConfig
    | undefined;
  const menuItems = onelineMenuAppConfig?.list?.[edition];

  const currentPageType = useCurrentPageType();

  if (!menuItems) return null;

  return (
    <Container>
      <StyledSwiper cssMode={false} navigation={false} pagination={false} slidesPerView="auto">
        {menuItems.map((item, index) => (
          <StyledSwiperSlide key={index}>
            <StyledBaseEntityLink
              linkEntity={item}
              query={{
                module: `oneline_menu_section_${edition}`,
                pgtype: currentPageType,
              }}
            >
              <MenuItem>{item.name}</MenuItem>
            </StyledBaseEntityLink>
          </StyledSwiperSlide>
        ))}
      </StyledSwiper>
    </Container>
  );
};

HeaderOnelineMenuItems.displayName = "HeaderOnelineMenuItems";
